import Vue from 'vue'

export default {
  strict: true,

  state: {
    feed: []
  },

  mutations: {
    SET_FEED (state, feed) {
      Vue.set(state, 'feed', feed)
    }
  },

  actions: {
    loadInstagramFeed ({ commit }) {
      Vue.http.get(process.env.API_URL + '/instagram/feed').then(function (response) {
        commit('SET_FEED', response.body.data)
      }).catch(function (response) {
        console.log('failed loading instagram feed')
      })
    }
  },

  getters: {
    instagramFeed (state) { return state.feed }
  }
}



// WEBPACK FOOTER //
// ./src/stores/instagram.js